import _ from 'lodash';
import {getAllAuthMarkets, getAuthCountries, getAuthMarkets, getCountries, getMarkets, getAdMarkets} from "@/api/common";
import {SET_KEEP_ALIVE_VIEWS, SET_NAV_MENU_TABS, SET_COUNTRIES, SET_MARKETS, SET_ADMARKETS, SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH, SET_USER_GUIDE_TASK_DATA,
  GET_USER_GUIDE_TASK_DATA, SET_IS_NEW_USER_TASK, SET_GUIDE_VISIBLE, SET_IS_SHOW_NOVICE_GUIDE, SET_USER_GUIDE_TASK_ITEM} from "@/store/mutation-types";
import {GET_AUTH_COUNTRIES, GET_AUTH_MARKETS, GET_COUNTRIES, GET_MARKETS, GET_ADMARKETS} from "@/store/action-types";
import { getTaskTenant, reverseTaskStatus } from "@/api/guide";

const SET_AUTH_COUNTRIES = 'SET_AUTH_COUNTRIES';
const SET_AUTH_MARKETS = 'SET_AUTH_MARKETS';

const state = {
  keepAliveViews: [],
  navMenuTabs: [
    {
      fullPath: "/dashboard",
      name: "Dashboard",
      componentName: "app-dashboard",
      path: "/dashboard",
      closable: false,
      fixed: false,
    }
  ],
  countries: [],
  markets: [],
  adMarkets: [],
  authCountries: [],
  authMarkets: [],

  // 新手任务引导模式
  userGuideState: false,
  userGuideMenuPath: '',
  // 新手任务状态数据
  userGuideTaskData:{},
  // 是否有新手任务
  isNewUserTask: false,
  // 新手任务是否完成
  guideVisible: false,
  //新手指导按钮是否删除，1已删除，0未删除
  isShowNoviceGuide: true,
  //进行中任务
  userGuideTaskItem: null
  
};

const mutations = {
  [SET_COUNTRIES](state, countries) {
    state.countries = countries
  },
  [SET_MARKETS](state, markets) {
    state.markets = markets
  },
  [SET_ADMARKETS](state, markets) {
    state.adMarkets = markets
  },
  [SET_AUTH_COUNTRIES](state, countries) {
    state.authCountries = countries
  },
  [SET_AUTH_MARKETS](state, markets) {
    state.authMarkets = markets
  },
  [SET_KEEP_ALIVE_VIEWS](state, keepAliveViews) {
    state.keepAliveViews = keepAliveViews
  },
  [SET_NAV_MENU_TABS](state, navMenuTabs) {
    state.navMenuTabs = navMenuTabs
  },
  [SET_USER_GUIDE_STATE](state, userGuideState) {
    state.userGuideState = userGuideState;
  },
  [SET_USER_GUIDE_MENU_PATH](state, userGuideMenuPath) {
    state.userGuideMenuPath = userGuideMenuPath;
  },
  [SET_USER_GUIDE_TASK_DATA](state, data) {
    state.userGuideTaskData = data;
  },
  [SET_IS_NEW_USER_TASK](state, isNewUserTask) {
    state.isNewUserTask = isNewUserTask;
  },
  [SET_GUIDE_VISIBLE](state, guideVisible) {
    state.guideVisible = guideVisible;
  },
  [SET_IS_SHOW_NOVICE_GUIDE](state, isShowNoviceGuide) {
    state.isShowNoviceGuide = isShowNoviceGuide;
  },
  [SET_USER_GUIDE_TASK_ITEM](state, userGuideTaskItem) {
    state.userGuideTaskItem = userGuideTaskItem;
  }
};

const actions = {
  // 获取国家
  [GET_COUNTRIES]({ commit }) {
    getCountries().then(response => {
      commit(SET_COUNTRIES, response);
    });
  },
  // 获取站点
  [GET_MARKETS]({ commit }) {
    getMarkets().then(response => {
      commit(SET_MARKETS, response);
    });
  },
  [GET_ADMARKETS]({ commit }) {
    getAdMarkets().then(response => {
      commit(SET_ADMARKETS, response);
    });
  },
  // 获取授权国家
  [GET_AUTH_COUNTRIES]({ commit }) {
    getAuthCountries().then(response => {
      commit(SET_AUTH_COUNTRIES, response);
    });
  },
  // 获取授权站点
  [GET_AUTH_MARKETS]({ commit }) {
    getAllAuthMarkets().then(response => {
      if(response&&response.length>0){
        let arr1 = [],arr2 = [];
        response.forEach(r=>{
          if(r.status === 'Inactive'){
            arr2.push(r);
          }else {
            arr1.push(r);
          }
        })
        response = arr1.concat(arr2)
      }
      commit(SET_AUTH_MARKETS, response);
    });
  },
   // 获取新手任务
  async [GET_USER_GUIDE_TASK_DATA]({ commit, dispatch }) {
    await getTaskTenant().then(data => {
      commit(SET_USER_GUIDE_TASK_DATA, data);
    }).catch(error => {
    })
  },
};

export default {
  state,
  mutations,
  actions
}
